<template>
    <section class="page-header">
        <div class="container">
            <div class="row align-items-end row-eq-height" style="margin-bottom: 18px">
                <div class="col-12 col-lg-7">
                    <h5 style="margin: 0" class="casafile">casafile - {{ $t('components.listingHeader.caption') }}</h5>
                </div>
                <div class="col-12 col-lg-5">
                    <ul class="breadcrumb" style="">
                        <li>
                            <router-link to="/">casafile</router-link>
                            </li>
                        <li>
                            <router-link :to="goToHouseType(this.listing.houseType)">{{ listing.houseType.localizedName | localized }}</router-link>
                        </li>
                        <li>
                            <router-link :to="goToRegion(this.listing.region)">{{ this.listing.region.localizedName | localized }}</router-link>
                        </li>
                        
                        <li class="active"><b>{{ $t('common.keywords.listing') }} {{ this.listing.objectId }}</b></li>
                    </ul>
                </div>
            </div>
            
            <div class="row row-eq-height">
                <div class="col-12" style="margin-bottom: 18px">
                    <h1>
                        {{ listing.localizedName | localized }}
                        <span class="subsentence">
                            {{ this.listing.shortDescription | localized}}
                        </span>
                    </h1>
                </div>
                <div class="col-12">
                    <h6>
                        {{ computedAddress }}
                    </h6>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'ListingHeader',
    props: {
        listing: {
            type: Object,
            required: true,
            default: () => {
                return undefined;
            }
        }
    },
    methods: {
        goToHouseType: function(houseType) {
            let locale = this.$i18n.locale;
            return `/search?houseType=${encodeURIComponent(houseType.localizedName[locale])}`;
        },
        goToRegion: function(region) {
            // TODO: Verify these are the correct links
            return region.url;
        }
    },
    computed: {
        computedAddress: function() {
            if (this.isUndefined(this.listing) || this.isUndefined(this.listing.address)) {
                return "";
            }
            const addr = this.listing.address;
            let strToReturn = this.listing.address.street;

            if (addr.number !== null) {
                strToReturn += " " + addr.number;
            }

            strToReturn += ", " + addr.cap + " " + addr.city;
            
            if (!this.isUndefined(this.listing.address.region)) {
                strToReturn += ", " + this.listing.address.region;
            }
            

            if (addr.nation !== null) {
                strToReturn += ", " + addr.nation;
            }

            return strToReturn;
        }
    }
}
</script>


<style lang="scss" scoped>
    .page-header {
        background-color: $white-01;
        border: 0;
    }

    a {
        color: $text-color;
        font-family: 'Noto Serif SC', serif;
    }

    h1 {
        border: 0;
        color: $text-color;
        font-family: 'Museo Sans', serif;
    }

    .subsentence {
        font-size: 14px;
        font-family: 'Noto Serif SC', serif;
    }

    h6 {
        font-weight: 500;
        font-size: 14px;
        font-family: 'Noto Serif SC', serif;
    }

    .casafile {
        font-size: 14px;
        font-family: "Noto Serif SC", serif;
        color: $text-color;
    }


    @media (min-width: 991.98px) {
        .breadcrumb {
            align-self: flex-end;
            justify-content: flex-end;
        }
    }
</style>